import { useQuery } from 'react-query';

import { assetsApi, shopGroupsApi, shopsApi, usersApi } from 'api';
import { QueryKey } from 'enums';
import { InternalTransfersPage } from 'features/internal-transfers';
import { useMeta, useShopsQuery, useUser } from 'hooks';

export const AdminInternalTransfersPage: React.FC = () => {
  const { role } = useUser();
  const { isShopGroupEnabled } = useMeta();

  const queryResultShops = useShopsQuery(
    QueryKey.Shops,
    shopsApi.getAllAsRole(role),
  );
  const queryResultUsers = useQuery(
    QueryKey.InternalTransfersUsers,
    usersApi.getAssetHoldersWithProvider,
  );
  const queryResultAssets = useQuery(QueryKey.Assets, assetsApi.getAll);
  const { data: shopGroups = [] } = useQuery(
    QueryKey.ShopGroups,
    shopGroupsApi.getAllAsRole(role),
  );

  return (
    <InternalTransfersPage
      queryResultUsers={queryResultUsers}
      queryResultShops={queryResultShops}
      queryResultAssets={queryResultAssets}
      shopGroups={isShopGroupEnabled ? shopGroups : undefined}
    />
  );
};
